import { render, staticRenderFns } from "./collectionInfo.vue?vue&type=template&id=2f9408a2&scoped=true&"
import script from "./collectionInfo.vue?vue&type=script&lang=js&"
export * from "./collectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./collectionInfo.vue?vue&type=style&index=0&id=2f9408a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9408a2",
  null
  
)

export default component.exports